var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatimentGauche2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 439 278",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4efed;}.cls-2,.cls-7{fill:#fff;}.cls-2,.cls-3,.cls-4,.cls-5{stroke:#fff;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{stroke-miterlimit:10;}.cls-2,.cls-3,.cls-4{stroke-width:3px;}.cls-3{fill:#d7d8e6;}.cls-4{fill:none;}.cls-5,.cls-9{fill:#e7e8f0;}.cls-6,.cls-8{fill:#304a54;opacity:0.38;}.cls-6{stroke:#304a54;}.cls-10{opacity:0.18;fill:url(#D\xE9grad\xE9_sans_nom_57);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_57",
    x1: 219.5,
    y1: 47,
    x2: 219.5,
    y2: 278.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ec8da",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6391b7"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Finaux") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "batiment_gauche_2",
    "data-name": "batiment gauche 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.38,
    y: 61.78,
    width: 438.62,
    height: 216.22
  }), /*#__PURE__*/React.createElement("g", {
    id: "fen\\xEAtres"
  }, /*#__PURE__*/React.createElement("g", {
    id: "double_fen\\xEAters",
    "data-name": "double fen\\xEAters"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 59.68,
    y: 78.6,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 77.6,
    y1: 77.99,
    x2: 77.6,
    y2: 107.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 30.03,
    y: 78.6,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 47.95,
    y1: 77.99,
    x2: 47.95,
    y2: 107.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 86.87,
    y: 78.6,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 104.78,
    y1: 77.99,
    x2: 104.78,
    y2: 107.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 180.77,
    y: 78.6,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 198.68,
    y1: 77.99,
    x2: 198.68,
    y2: 107.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 180.77,
    y: 142.85,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 198.68,
    y1: 142.24,
    x2: 198.68,
    y2: 171.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 180.77,
    y: 207.1,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 198.68,
    y1: 206.48,
    x2: 198.68,
    y2: 236.14
  })), /*#__PURE__*/React.createElement("g", {
    id: "double_fen\\xEAters-2",
    "data-name": "double fen\\xEAters"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 58.45,
    y: 142.85,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 76.36,
    y1: 142.24,
    x2: 76.36,
    y2: 171.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 30.03,
    y: 142.85,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 47.95,
    y1: 142.24,
    x2: 47.95,
    y2: 171.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 86.87,
    y: 142.85,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 104.78,
    y1: 142.24,
    x2: 104.78,
    y2: 171.89
  })), /*#__PURE__*/React.createElement("g", {
    id: "double_fen\\xEAters-3",
    "data-name": "double fen\\xEAters"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 59.68,
    y: 207.1,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 77.6,
    y1: 206.48,
    x2: 77.6,
    y2: 236.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 30.03,
    y: 207.1,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 47.95,
    y1: 206.48,
    x2: 47.95,
    y2: 236.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 86.87,
    y: 207.1,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 104.78,
    y1: 206.48,
    x2: 104.78,
    y2: 236.14
  })), /*#__PURE__*/React.createElement("g", {
    id: "double_fen\\xEAters-4",
    "data-name": "double fen\\xEAters"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 299.38,
    y: 78.6,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 317.3,
    y1: 77.99,
    x2: 317.3,
    y2: 107.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 273.44,
    y: 78.6,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 291.35,
    y1: 77.99,
    x2: 291.35,
    y2: 107.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 330.27,
    y: 78.6,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 348.19,
    y1: 77.99,
    x2: 348.19,
    y2: 107.64
  })), /*#__PURE__*/React.createElement("g", {
    id: "double_fen\\xEAters-5",
    "data-name": "double fen\\xEAters"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 300.62,
    y: 142.85,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 318.53,
    y1: 142.24,
    x2: 318.53,
    y2: 171.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 273.44,
    y: 142.85,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 291.35,
    y1: 142.24,
    x2: 291.35,
    y2: 171.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 330.27,
    y: 142.85,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 348.19,
    y1: 142.24,
    x2: 348.19,
    y2: 171.89
  })), /*#__PURE__*/React.createElement("g", {
    id: "double_fen\\xEAters-6",
    "data-name": "double fen\\xEAters"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 300.62,
    y: 207.1,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 318.53,
    y1: 206.48,
    x2: 318.53,
    y2: 236.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 273.44,
    y: 207.1,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 291.35,
    y1: 206.48,
    x2: 291.35,
    y2: 236.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 330.27,
    y: 207.1,
    width: 34.6,
    height: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 348.19,
    y1: 206.48,
    x2: 348.19,
    y2: 236.14
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 402.55,
    y: 103.93,
    width: 21.62,
    height: 13.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 429.73,
    y: 103.93,
    width: 8.03,
    height: 13.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 402.55,
    y: 169.42,
    width: 21.62,
    height: 13.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 429.73,
    y: 169.42,
    width: 8.03,
    height: 13.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 402.55,
    y: 232.43,
    width: 21.62,
    height: 13.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 429.73,
    y: 232.43,
    width: 8.03,
    height: 13.59
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 28.8,
    y1: 75.37,
    x2: 122.7,
    y2: 75.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1,
    y1: 63.63,
    x2: 438.38,
    y2: 63.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 28.8,
    y1: 139,
    x2: 122.7,
    y2: 139
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 28.8,
    y1: 203.25,
    x2: 122.7,
    y2: 203.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 272.2,
    y1: 75.37,
    x2: 366.1,
    y2: 75.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 272.2,
    y1: 139,
    x2: 366.1,
    y2: 139
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 272.2,
    y1: 203.25,
    x2: 366.1,
    y2: 203.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 179.53,
    y1: 75.37,
    x2: 216.6,
    y2: 75.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 179.53,
    y1: 139,
    x2: 216.6,
    y2: 139
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 179.53,
    y1: 203.25,
    x2: 216.6,
    y2: 203.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0.38,
    y: 38.92,
    width: 438.62,
    height: 23.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 384.64,
    y1: 8.03,
    x2: 398.84,
    y2: 8.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 401.93,
    y1: 101.93,
    x2: 438.38,
    y2: 101.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 401.93,
    y1: 167.42,
    x2: 438.38,
    y2: 167.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 401.93,
    y1: 230.43,
    x2: 438.38,
    y2: 230.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 371.04,
    y: 3.71,
    width: 39.54,
    height: 34.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "371.04 13.54 368.57 13.59 364.87 4.94 364.87 0 416.76 0 416.76 4.94 413.05 13.59 410.58 13.59 410.58 3.71 371.04 3.71 371.04 13.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "371.04 13.59 368.57 13.59 364.87 4.94 364.87 1.83 416.26 1.83 416.76 2.47 416.76 4.94 413.05 13.59 410.58 13.59 410.58 3.71 371.04 3.71 371.04 13.59"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 384.64,
    y: 8.65,
    width: 13.59,
    height: 12.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    y: 47,
    width: 439,
    height: 231.56
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatimentGauche2);
export default __webpack_public_path__ + "static/media/batiment_gauche_2.f448dc70202955188ccd5b5c76e66e2e.svg";
export { ForwardRef as ReactComponent };